import { IntegrationServices } from '@sequencehq/api/utils/commonEnums'
import { SimpleModal, Box } from '@sequencehq/core-components'
import { FC } from 'react'
import { GreyGrey80, Primary13Regular } from '@sequencehq/core-components'
import { getIntegrationName } from 'Integrations/utils/getIntegrationName'
import { useMutation } from '@sequencehq/api/utils'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { useNotifications } from '@sequencehq/core-components'

const useUnlinkCreditNoteModal = (props: {
  service: IntegrationServices
  creditNoteId: string
}) => {
  const { displayNotification } = useNotifications()

  const unlinkingMutation = useMutation(
    dashboard20240730Client.deleteLinkedEntity
  )

  const serviceName = getIntegrationName(props.service)
  const onUnlink = async (): Promise<boolean> => {
    try {
      await unlinkingMutation.mutateAsync({
        type: 'CREDIT_NOTE',
        id: props.creditNoteId,
        service: props.service
      })
      displayNotification(`Credit note unlinked from ${serviceName}`, {
        type: 'success'
      })
      return true
    } catch {
      displayNotification(`Could not unlink credit note from ${serviceName}`, {
        type: 'error'
      })
      return false
    }
  }

  return { serviceName, onUnlink, unlinking: unlinkingMutation.isPending }
}

export const UnlinkCreditNoteModal: FC<{
  creditNoteId: string
  service: IntegrationServices
  onClose: () => void
}> = props => {
  const hook = useUnlinkCreditNoteModal({
    service: props.service,
    creditNoteId: props.creditNoteId
  })

  return (
    <SimpleModal
      isOpen
      variant="dialog"
      onClose={props.onClose}
      data-testid="modal.unlinkCreditNote"
      title={`Unlink Credit note from ${hook.serviceName}`}
      isDestructive
      disableSubmitOnEnter
      submitButtonText="Unlink"
      submittingButtonText="Unlinking..."
      cancelButtonText="Cancel"
      submitting={hook.unlinking}
      onSubmit={hook.onUnlink}
    >
      <Box color={GreyGrey80} {...Primary13Regular} flex={1}>
        This will unlink the credit note from {hook.serviceName} immediately.
        You can re-link the credit note again if required.
      </Box>
    </SimpleModal>
  )
}
